export type ModelMode = "normal" | "pro";

export interface ModelModeConfig {
  label: string;
  displayModel: string;
  enabled: boolean;
  backendModel: string;
  warning?: string;
}

/** Config-driven model modes — add entries when new deployments are connected. */
export const MODEL_CONFIG: Record<ModelMode, ModelModeConfig> = {
  normal: {
    label: "Normal Mode",
    displayModel: "GPT-4o-mini",
    enabled: true,
    backendModel: "gpt-4o-mini-support",
  },
  pro: {
    label: "PRO Mode",
    displayModel: "GPT-5",
    enabled: false,
    backendModel: "gpt-5",
    warning: "Do not use the PRO model without authorization.",
  },
};

export const MODEL_MODE_STORAGE_KEY = "copilot_model_mode";

export function resolveModelMode(requested: ModelMode): {
  effective: ModelMode;
  notice: string | null;
} {
  const cfg = MODEL_CONFIG[requested];
  if (!cfg.enabled) {
    return {
      effective: "normal",
      notice: `${cfg.label} (${cfg.displayModel}) is not available yet. Using ${MODEL_CONFIG.normal.label}.`,
    };
  }
  return { effective: requested, notice: null };
}
